




























































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  ProjectFilter,
  ProjectTimeEntryViewModel, StopwatchViewModel,
  StSelectListItemGroup,
  TagViewModel
} from "@/services/api/nswag/stapiclient_generated";
import { stProjectApi } from "@/services/st-api";
import { UserStore } from "@/store/user-module";
import { StopwatchStore } from "@/store/stopwatch-store";
import { TimeEntryStore } from "@/store/time-entry-store";
import StBadge from "@/components/basic/StBadge.vue";
import { notifySuccess } from "@/utlitities/notifications";
import StopwatchSelect from "@/views/Stopwatch/OldLayout/StopwatchSelect.vue";
import StarRating from "vue-star-rating";

Component.registerHooks(["beforeRouteUpdate"]);

@Component({
  components: { StBadge, StopwatchSelect, StarRating }
})
export default class StopwatchOldLayout extends Vue {
  lastProjects: StSelectListItemGroup[] = [];
  projects: StSelectListItemGroup[] = [];
  selectedProject: ProjectTimeEntryViewModel = new ProjectTimeEntryViewModel();
  tags: TagViewModel[] = [];
  projectId: number = 0;
  changeProjectFlag: boolean = false;

  loading = false;

  private startStopLoading: boolean = false;
  private delLoading: boolean = false;

  get openTimeEntryWhenStopStopwatch(){
    return UserStore.userSettings.openTimeEntryWhenStopStopwatch;
  }

  get canViewRates() {
    return UserStore.userSettings.CanViewRates && !UserStore.userSettings.noRates;
  }

  get useProjectTimeTracking() {
    return !UserStore.userSettings.useBasicTimeTracking && !UserStore.userSettings.isBasicTimeTrackingUser
  }

  get currency() {
    return UserStore.userSettings.currency;
  }

  get stopwatch() {
    return StopwatchStore.StopwatchModel;
  }

  getExtraFields(stopwatch: StopwatchViewModel) {
    return stopwatch.timeEntryExtraFields?.filter(x => !x.hideInDayView) ?? [];
  }

  get isRunning() {
    return StopwatchStore.IsRunning;
  }

  get durationSeconds() {
    return StopwatchStore.RunningSeconds;
  }

  get userSettings() {
    return UserStore.userSettings;
  }

  //
  get selectedProjectHasTasks() {
    return this.selectedProject.hasProjectTasks;
  }

  get hasProjectTasks() {
    return UserStore.userSettings.hasProjectTasks;
  }

  @Watch("isRunning")
  async runningChanged() {
    if (!this.isRunning) {
      await this.loadData();
    }
  }

  async mounted() {
    try {
      this.loading = true;

      await this.loadData();
    } finally {
      this.loading = false;
    }
  }

  async loadData() {
    try {
      this.loading = true;
      this.projects = await stProjectApi.getSelectListForTimeTracking();

      this.lastProjects = await stProjectApi.getSelectListOnlyLastUsed(10, true);

      this.projectId = this.lastProjects[0]!.items![0].id!;
    } finally {
      this.loading = false;
    }
  }

  async startDefaultStopwatch() {
    await this.start(this.projectId);
  }

  async changeProject(projectId: number) {
    try {
      this.loading = true;

      this.changeProjectFlag = false;
      await this.stop();
      await this.start(projectId);
    } finally {
      this.loading = false;
    }
  }

  async start(projectId: number) {
    try {
      this.projectId = projectId;
      this.startStopLoading = true;
      await StopwatchStore.startStopwatchForProject(projectId);
    } finally {
      this.startStopLoading = false;
    }
  }

  edit() {
    if (this.startStopLoading || this.delLoading) {
      return;
    }
    this.$router.push({ name: "StopwatchOldLayoutEdit" });
  }

  async loadConnectedData() {
    await TimeEntryStore.LoadTimeEntryDays(TimeEntryStore.SelectedDate);
  }

  async stop() {
    try {
      if(this.openTimeEntryWhenStopStopwatch){
        await this.$router.push({name: 'TimeEntryAddFromStopwatch'})
        return;
      }
      this.startStopLoading = true;
      await StopwatchStore.stopStopwatch();
      this.startStopLoading = false;
      this.loading = true;
      await this.loadConnectedData();
      notifySuccess("Stoppuhr gestoppt");
    } finally {
      this.loading = false;
      this.startStopLoading = false;
    }
  }

  async deleteStopwatch() {
    try {
      this.delLoading = true;
      await StopwatchStore.deleteStopwatch();
      this.delLoading = false;
      this.loading = true;
      await this.loadConnectedData();
      notifySuccess("Stoppuhr gelöscht");
    } finally {
      this.loading = false;
      this.delLoading = false;
    }
  }
}
